// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import Mask from '/react4xp/components/Mask'
import Balloon from '/react4xp/components/Balloon'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
interface ContactCardProps {
    section?: {
        paddingTop?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    }
    title?: string
    src?: string
    alt?: string
    infos?: {
        name?: string
        position?: string
        phone?: string
        email?: string
    }
}

export default function ContactCard({
    section,
    title,
    src,
    alt,
    infos
}: ContactCardProps) {
    return (
        <Section
            bgColor='yoghurt'
            paddingTop={section?.paddingTop}
            paddingBottom={section?.paddingBottom}
            className='contact-card'
        >
            <div className='container'>
                <div className='contact-card__grid'>

                    <div className='contact-card__grid__left'>
                        {isNonWhitespaceString(title) && (
                            <Balloon
                                balloonColor='white'
                                spacing='small'
                                arrowSize='small'
                                arrow='bottom-middle'
                                balloonSide='left'
                                arrowSide='right'
                            >
                                <h2 className='h2 line-break'>
                                    {title}
                                </h2>
                            </Balloon>
                        )}
                    </div>

                    <div className='contact-card__grid__middle'>
                        {src && (
                            <Mask>
                                <Image
                                    src={src}
                                    alt={alt}
                                    width={400} // 400x350
                                    className='cover'
                                />
                            </Mask>
                        )}
                    </div>

                    <div className={clsx('contact-card__grid__right', src && 'contact-card__grid__right--has-image')}>
                        {infos && (
                            <Mask bgColor='white'>

                                {isNonWhitespaceString(infos.name) && (
                                    <h3 className='name text-big'>
                                        <strong>
                                            {infos.name}
                                        </strong>
                                    </h3>
                                )}

                                {isNonWhitespaceString(infos.position) && (
                                    <p className='position'>
                                        <b>
                                            {infos.position}
                                        </b>
                                    </p>
                                )}

                                <div className='links text-small'>

                                    {isNonWhitespaceString(infos.phone) && (
                                        <a href={`tel:${infos.phone}`} className='regular-link'>
                                            {infos.phone}
                                        </a>
                                    )}

                                    {isNonWhitespaceString(infos.email) && (
                                        <a href={`mailto:${infos.email}`} className='regular-link'>
                                            {infos.email}
                                        </a>
                                    )}

                                </div>

                            </Mask>
                        )}
                    </div>

                    <div className='cf'></div>

                </div>
            </div>
        </Section>
    )
}